import { Box, Button, Icon, Text } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

import { MODES } from '../constants';

import type { MODES_VALUES } from '../constants';

const CONFIG = {
  phone: {
    bodyText: `Your number has been verified. You’re done.`,
  },
  email: {
    bodyText: `Your email has been verified. You’re done.`,
  },
};

type Props = {
  showVerificationModal: (value: boolean) => void;
  verificationSuccessfulCTAText: string;
  verificationMode?: MODES_VALUES;
};

const Finished = ({
  showVerificationModal,
  verificationSuccessfulCTAText,
  verificationMode = MODES.PHONE,
}: Props): JSX.Element => (
  <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
    <Icon
      size="xl"
      css={{
        color: 'icon.feedback.success.strong',
        marginTop: '0',
        marginInline: 'auto',
        marginBottom: '200',
        display: 'block',
        height: '2500',
        width: '2500',
      }}
      render={<IconCheckmarkCircleFilled />}
    />
    <Text textStyle="body-bold">Success</Text>
    <Text css={{ marginTop: '200', textAlign: 'center' }} asChild>
      <p>{CONFIG[verificationMode].bodyText}</p>
    </Text>
    <Box css={{ marginTop: '400' }}>
      <Button
        tone="brand"
        emphasis="filled"
        onClick={() => showVerificationModal(false)}
        css={{
          minWidth: '5000',
          display: 'block',
          margin: '0 auto',
        }}
      >
        {verificationSuccessfulCTAText}
      </Button>
    </Box>
  </Box>
);

export default Finished;
